// Cobertura = cuantos de los que DEBERIAN tener el plan ya lo tienen. Es lo que
// permite avisar "3 jugadores del grupo sin plan" cuando entra alguien nuevo,
// sin cobrarle a nadie a sus espaldas.

export const ESTADO_PLAN = {
  SIN_PLAN: 'sin_plan',
  CON_ESTE: 'con_este_plan',
  CON_OTRO: 'con_otro_plan',
}

export const coberturaDeGrupo = ({ inscritosDelGrupo = [], planId = null, planesDe = {} } = {}) => {
  const { sinPlan, conEste, conOtro } = desglosarPorPlan(inscritosDelGrupo, planId, planesDe)
  // Con un plan elegido, "falta" tambien quien tiene OTRO: se le reemplaza (y el
  // dialogo lo avisa). Sin plan elegido no hay contra que comparar, asi que solo
  // falta quien no tiene ninguno -- reemplazarle el plan a alguien sin saber
  // cual seria una decision que el admin no tomo.
  const faltantes = planId ? [...sinPlan, ...conOtro] : sinPlan
  return {
    inscritos: inscritosDelGrupo.length,
    sinPlan,
    conEste,
    conOtro,
    faltantes,
    // Un grupo vacio no es "completo": no hay nada cubierto, y pintarlo en verde
    // haria creer que ya se atendio.
    completo: inscritosDelGrupo.length > 0 && faltantes.length === 0,
  }
}

export const coberturaDeFamilia = ({ jugadoresDeFamilia = [], planId = null, planesDe = {} } = {}) =>
  coberturaDeGrupo({ inscritosDelGrupo: jugadoresDeFamilia, planId, planesDe })

// El renglon de cobertura de Grupos y Familias, en el MISMO idioma que los
// badges de la vista Jugadores y que el dialogo: "ya lo tienen" / "con otro
// plan" / "sin plan". Antes las dos vistas decian "N con plan · N sin plan"
// leyendo un conjunto que significaba "tiene el plan elegido" cuando habia plan
// y "tiene cualquier plan" cuando no: un grupo donde todos tenian OTRO plan se
// pintaba "18 inscritos · 0 con plan · 18 sin plan", y esa es justo la vista
// que dispara la accion masiva.
export const resumenCobertura = (cobertura, { planId = null, sustantivo = 'inscritos' } = {}) => {
  const { inscritos = 0, sinPlan = [], conEste = [], conOtro = [] } = cobertura || {}
  if (!inscritos) return `Sin ${sustantivo}`
  const partes = [`${inscritos} ${sustantivo}`]
  if (planId) {
    if (conEste.length) partes.push(`${conEste.length} ya lo tienen`)
    if (conOtro.length) partes.push(`${conOtro.length} con otro plan`)
  } else if (conOtro.length) {
    partes.push(`${conOtro.length} con plan`)
  }
  if (sinPlan.length) partes.push(`${sinPlan.length} sin plan`)
  return partes.join(' · ')
}

// Filtro de cobertura para las vistas de Familias/Grupos: 'completos' /
// 'faltantes' / '' (sin filtrar, todos pasan). Separado de filtrarJugadores
// porque aqui el candidato ya es una cobertura calculada, no un jugador.
export const pasaCobertura = (filtroCobertura, cobertura) => {
  if (!filtroCobertura) return true
  return filtroCobertura === 'completos' ? cobertura.completo : cobertura.faltantes.length > 0
}

export const estadoPlanDeJugador = (jugadorId, planId, planesDe = {}) => {
  const suyos = planesDe[jugadorId] || []
  if (planId && suyos.includes(planId)) return ESTADO_PLAN.CON_ESTE
  return suyos.length ? ESTADO_PLAN.CON_OTRO : ESTADO_PLAN.SIN_PLAN
}

// Los tres cubos de "que le pasa a cada uno si asigno este plan":
//   sinPlan  -> se le genera y ya
//   conEste  -> no se duplica; solo se le completan las parcialidades que falten
//   conOtro  -> se le REEMPLAZA el plan y se le CANCELAN sus cargos pendientes
//               de los conceptos que compartan (ver reasignarPlanJugador)
// Es el mismo lenguaje en el dialogo de confirmacion y en las vistas de
// Grupos/Familias: el total suelto ("48 jugadores") escondia el tercer cubo,
// que es justo el destructivo. Sin plan elegido, conEste queda vacio y conOtro
// significa "tiene algun plan".
export const desglosarPorPlan = (jugadorIds = [], planId = null, planesDe = {}) => {
  const sinPlan = []
  const conEste = []
  const conOtro = []
  jugadorIds.forEach((id) => {
    const estado = estadoPlanDeJugador(id, planId, planesDe)
    if (estado === ESTADO_PLAN.CON_ESTE) conEste.push(id)
    else if (estado === ESTADO_PLAN.CON_OTRO) conOtro.push(id)
    else sinPlan.push(id)
  })
  return { total: jugadorIds.length, sinPlan, conEste, conOtro }
}

// Lo que cuesta el plan por jugador, antes de promociones y descuentos por
// hermanos (esos los calcula el servicio al generar los cargos).
export const totalDelPlan = (plan) =>
  (plan?.pagos_planes_items || []).reduce((s, it) => s + Number(it.monto || 0), 0)

export const filtrarJugadores = (jugadores = [], filtros = {}, ctx = {}) => {
  const { estadoPlan, grupoId, deporte, anios = [], rama, conAdeudo } = filtros
  const { planId = null, planesDe = {}, adeudoDe = new Set(), gruposDe = {}, deportesDe = {} } = ctx
  return jugadores.filter((j) => {
    if (estadoPlan && estadoPlanDeJugador(j.id, planId, planesDe) !== estadoPlan) return false
    if (grupoId && !(gruposDe[j.id] || []).includes(grupoId)) return false
    if (deporte && !(deportesDe[j.id] || []).includes(deporte)) return false
    if (rama && (j.genero || '').toLowerCase() !== rama) return false
    if (conAdeudo && !adeudoDe.has(j.id)) return false
    if (anios.length) {
      const anio = j.fecha_nacimiento ? Number(String(j.fecha_nacimiento).slice(0, 4)) : null
      if (!anio || !anios.includes(anio)) return false
    }
    return true
  })
}
